import React, { useContext, useMemo, useState, useEffect } from 'react';

import { FormikContext as FormContext } from 'formik';

import { Button } from '@gogame/components';

export const SubmitButton = ({
  title = 'Save',
  onSubmit,
  disabled = false,
  ...props
}) => {
  const { submitForm, loadingCount, dirty } = useContext(FormContext);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!active) {
      if (loadingCount > 0) {
        setActive(true);
      }
      if (loadingCount === 0) {
        const timer = setTimeout(() => {
          if (!active && loadingCount === 0) {
            setActive(true);
          }
        }, 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [loadingCount, active]);

  const calcDisabled = useMemo(
    () => disabled || loadingCount > 0 || !active || !dirty,
    [disabled, active, loadingCount, dirty]
  );

  const handleSubmit = (submitProps) => {
    return onSubmit ? onSubmit(submitProps) : submitForm(submitProps);
  };

  return (
    <Button
      onClick={handleSubmit}
      disabled={calcDisabled}
      variant={'contained'}
      role={'button'}
      {...props}
    >
      {title}
    </Button>
  );
};
